import { Typography } from '@mui/material';
import { styled } from '@mui/system';

const RootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  border: '1px solid #EAEAEA',
  borderRadius: '10px',
});

const TitleTypography = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#414046',
  marginBottom: '12px',
  textAlign: 'left',
  marginLeft: '12px',
  marginTop: '12px',
});

const SubTitleTypography = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#414046',
  textAlign: 'left',
  marginLeft: '12px',
  marginTop: '10px',
  marginBottom: '10px',
});

const DivisionLine = styled('div')({
  height: '1px',
  backgroundColor: '#EAEAEA',
  width: '100%',
});

const InformationTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontStyle: 'italic',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.16px',
  textAlign: 'left',
  color: '#757475',
  marginLeft: '12px',
  marginTop: '-8px',
  marginBottom: '10px',
});

const InsuranceSubtitleContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 12px 0 12px',
});

const InsuranceColumnContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
});

const IconContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
});

const PaymentMethodItem = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginLeft: '10px',
  cursor: 'default',
  opacity: 1,
  padding: '12px 15px',
  gap: 0,
});

export {
  RootDiv,
  TitleTypography,
  SubTitleTypography,
  DivisionLine,
  InformationTypography,
  InsuranceSubtitleContainer,
  InsuranceColumnContainer,
  IconContainer,
  PaymentMethodItem,
};
